import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAxios } from '../../common_nextgen/axios/AxiosHelper';
import FunctionKeys from '../../common_nextgen/common_components/FunctionKeys/FunctionKeys';
import useCustomNavigate from '../../common_nextgen/common_components/Navigation/NextGenNavigation';
import Form from '../../common_nextgen/common_components/form/Form';
import { useToast } from '../../common_nextgen/hooks/ToastContext';
import { PRICE_SCHEDULE_MODES, ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import {
    isAddMode,
    isEditMode,
    isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields } from './DeductibleScheduleStepDetailExtensionFormConfig';
import { useRBAC } from '../../common_nextgen/hooks/RBACContext';


const screenInfo = {
    ADD: ['Deductible Schedule Step Detail Extension', 'RCDDE001'],
    CHANGE: ['Deductible Schedule Step Detail Extension', 'RCDDE001'],
    VIEW: ['Deductible Schedule Step Detail Extension', 'RCDDE001'],
};

const DeductibleScheduleStepDetailExtensionForm = ({ mode }) => {
    const {writeAccess} = useRBAC();
    const location = useLocation();
    const { DEDUCTIBLE_SCHEDULE, DEDUCTIBLE_SCHEDULE_STEPS } = ROUTE_PATHS;
    const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedSteps=[],
    previousScreen = DEDUCTIBLE_SCHEDULE_STEPS,
    currentIndex: initialIndex = 0,
    initialParamsData = {
        dscScheduleName: selectedSteps[initialIndex].dscScheduleName,
        dscDescription: selectedSteps[initialIndex].dscDescription,
        dsdCrossOverFlag:selectedSteps[initialIndex].dsdCrossOverFlag,
    }
  } = currentState;
console.log("sel sch", selectedSteps);
    const navigateToPage = useCustomNavigate();
    const [selectedOption, setSelectedOption] = useState('no');
    const [currentIndex, setCurrentIndex] = useState(initialIndex);
    const [currentMode, setCurrentMode] = useState(mode);
    const [initialFormData, setInitialFormData] = useState({});
    const [dataForSubmission, setDataForSubmission] = useState({});
    const [constraintErrors, setConstraintErrors] = useState([]);
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const toast = useToast();
    const { axios_helper_no_header } = useAxios();

    // const handleBack = () => {
    //     if (currentIndex < selectedSteps.length - 1) {
    //         setCurrentIndex(currentIndex + 1);
    //         setCurrentMode(mode);
    //     } else {
    //         navigateToPage(DEDUCTIBLE_SCHEDULE, { priceSchedule: selectedSteps[currentIndex] });
    //     }
    // };

    const handleBack = () => {
        if (currentIndex < selectedSteps.length - 1) {
            setCurrentIndex(currentIndex + 1);
            setCurrentMode(mode);
        } else {
            navigateToPage(previousScreen, previousState);
        }
    };

    const getPageTitle = useCallback(() => {
        const [screenTitle, screenNumber] = isAddMode(currentMode) ? screenInfo.ADD : screenInfo.CHANGE;
        return (
            <>
                <span className="title">{screenTitle}</span>
                <span>{'-'}</span>
                <span className="screen-number">{screenNumber}</span>
            </>
        );
    }, [currentMode]);


    const paramsData = useMemo(() => {
        const {
            dscScheduleName,
            dsdStepNumber,
            dscDescription,
            dsdCrossOverFlag
        } = selectedSteps[currentIndex]
        const params = {
            dscScheduleName,
            dsdStepNumber,
            dscDescription,
            dsdCrossOverFlag
        }
        return params;
    }, [currentIndex, selectedSteps])

    const submitForm = async (dataForSubmission) => {
        let url = '';
        let verb = '';
        let screenNumber = '';

        if (isAddMode(currentMode)) {
            url = 'api/ddeDedSchDtlExt';
            verb = 'PUT';
            screenNumber = screenInfo.ADD[1];
        } else {
            url = 'api/ddeDedSchDtlExt';
            verb = 'PUT';
            screenNumber = screenInfo.CHANGE[1];

            if (JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)) {
                toast.current.show({ severity: 'info', summary: '', detail: 'No Change of Information', life: 3000 });
                return;
            }
        }

        const data = { ...dataForSubmission, screenNumber, dsdCrossOverFlag: paramsData.dsdCrossOverFlag };

        try {
            const { responseStatus, responseData } = await axios_helper_no_header(verb, url, data, null);
            setInitialFormData(responseData);
            setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
            toast.current.show({ severity: 'success', summary: '', detail: responseStatus.message, life: 3000 });
        } catch (error) {
            const { responseStatus: { displayErrorFields = null, message } } = error.data;
            if (displayErrorFields === null) {
                toast.current.show({ severity: 'error', summary: '', detail: message, life: 3000 });
            } else {
                setConstraintErrors(displayErrorFields);
            }
        }
    };

    const [keyFunc, keyName] = useMemo(() => {
        const keyFunc = {};
        const keyName = {};

        if (isAddMode(currentMode)) {
            keyFunc.F12 = handleBack;
            keyName.F12 = 'Back';
        } else if (isEditMode(currentMode)) {
            keyFunc.F12 = handleBack;
            keyName.F12 = 'Back';
            keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
            keyName.chmod = 'View';
        } else if (isReadOnlyMode(currentMode)) {
            keyFunc.F12 = handleBack;
            keyName.F12 = 'Back';
            keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
            keyName.chmod = 'Edit';
        }

        return [keyFunc, keyName];
    }, [currentMode, currentIndex]);

    useEffect(() => {
        const fetchInitialData = async () => {
            const url = isAddMode(mode) ? 'api/ddeDedSchDtlExt/initialFormData/' + screenInfo.ADD[1] : 'api/ddeDedSchDtlExt/initialFormData/' + screenInfo.EDIT[1];
            try {
                const { responseData } = await axios_helper_no_header('GET', url, null, paramsData);
                setInitialFormData(responseData);

                const { addDate } = responseData;
                if (addDate) {
                     setCurrentMode(writeAccess ? PRICE_SCHEDULE_MODES.EDIT : PRICE_SCHEDULE_MODES.READ_ONLY);
                }
            } catch (error) {
                console.log(error);
            }
        };

        fetchInitialData();
    }, [mode, currentIndex]);

    return (
        <div className="grid container">
            <div className="col col-12">
                <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
            </div>
            <div className="col col-12">
                <h1>{getPageTitle()}</h1>
            </div>
            <div className="col col-12">
                <Form
                    formData={initialFormData}
                    formFields={formFields}
                    mode={currentMode}
                    submitFormData={submitForm}
                    constraintErrors={constraintErrors}
                />
            </div>
        </div>
    );
};

export default DeductibleScheduleStepDetailExtensionForm;  
